// Module
var code = "<a class=\"btn blue subFormControl\"> <i class=\"fa fa-user-circle\"></i> </a>";
// Exports
export default code;